<template>
	<div style="position:relative" :style="{ width: size + 'px', height: size + 'px' }">
		<img v-if="url" class="image" :width="size" :height="size" :src="url" @load="imageLoaded" alt="Medarbejder billede" />
		<div v-if="url" class="spinbox" :style="{'top':spinnerOffset+'px','left':spinnerOffset+'px'}">
			<WaitSpinner color="#135" :run="isLoading" :size="spinnerSize" shadowColor="#ffffff"></WaitSpinner>
		</div>
		<div v-if="!url&&initials" class="initials" :style="{ width: size + 'px', height: size + 'px', fontSize: size/2.5 + 'px' }">
			<div>{{ initials }}</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import WaitSpinner from '@/components/WaitSpinner.vue'
import { useSettingsStore } from '@/stores/Settings'
import { computed, ref } from 'vue'

const ss = useSettingsStore()

interface Props {
	picture?: string
	size: number
	name?: string
}

const props = withDefaults(defineProps<Props>(), { size: 16 })
const isLoading = ref(true)

function imageLoaded() {
	isLoading.value = false
}

const initials = computed(() => {
	if (!props.name) { return '' }

	// Only words that start with a letter or digit: a tag such as "(gæst)" is no name
	const parts = props.name.split(/ +/).filter(part => /^[\p{L}\p{N}]/u.test(part))
	let out = ''

	if (parts[0]) { out += parts[0][0] }
	if (parts.length > 1 && parts[parts.length - 1]) { out += parts[parts.length - 1]?.[0] ?? '' }
	return out.toUpperCase()
})

const url = computed(() => {
	if (props.picture && ss.token) {
		return `https://image.telecomx.dk/${props.picture}.jpg?width=300&height=300&token=${ss.token}`
	} else if (initials.value) {
		return ''
	} else {
		return 'https://image.telecomx.dk/5cb5ce081abcc110ca68f034.png' // Dummy person picture
	}
})

const spinnerSize = computed(() => {
	return (props.size / 100) * 80
})

const spinnerOffset = computed(() => {
	return (props.size - ((props.size / 100) * 80)) / 2
})
</script>

<style scoped>
	.image {
		background-color: var(--p-form-field-background);
		border: 1px solid var(--p-form-field-border-color);
		border-radius: 50%;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.spinbox {
		position: absolute;
	}
	.initials {
		background-color: var(--p-surface-200);
		color: var(--p-form-field-color);
		border: 1px solid var(--p-form-field-border-color);
		border-radius: 50%;
		position: absolute;
		top: 0;
		left: 0;
		text-transform: uppercase;
		font-weight: 200;
		text-align: center;
		padding-top: 6px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	@media(prefers-color-scheme: dark) {
		.initials {
			background-color: var(--p-surface-950);
			border: 1px solid #333;
			color: #BBAC91;
		}
		.image {
			background-color: var(--p-surface-950);
			border: 1px solid #333;
		}
	}
	.initials > DIV {
		margin-top: -6px;
	}
</style>
